<template>
  <div class="layer-dark">
    <div class="login-box">
      <div class="login-wrap popup">
        <button class="icon-close" @click="hideLoginPopup" />
        <h1 class="logo">
          <div class="site-logo" />
        </h1>
        <h2 class="tx-center pc-txt popup-tit">
          {{ $t('로그인하고캠페인참여하기') }}
        </h2>
        <div class="input-wrap">
          <div class="input">
            <input v-model="id" type="text" :placeholder="$t('watv아이디')">
            <input v-model="password" type="password" :placeholder="$t('비밀번호')" @keyup.enter="login">
          </div>
          <p v-if="invalidMessage !== ''" class="error-message" v-html="invalidMessage" />
          <button class="login-button" @click="login">
            {{ $t('로그인') }}
          </button>
        </div>
        <!--  -->
        <div class="sns-wrap">
          <p
            class="tx-center desc"
            v-html="$t('watv회원이아니신가요brdatavcb97457a카카오톡또는구글계정으로간편하게이용할수있습니')"
          />
          <div class="btn-group sns-button">
            <button class="sns-kakao" @click="loginWithKakao">
              <i class="icon-kakao" />
              <span>{{ $t('kakao로시작하기') }}</span>
              <div v-if="recentlyLoginSns === 'kakao'" class="recent">
                {{ $t('최근로그인') }}
              </div>
            </button>
            <button class="sns-google" @click="loginWithGoogle">
              <i class="icon-google" />
              <span>{{ $t('google로시작하기') }}</span>
              <div v-if="recentlyLoginSns === 'google'" class="recent">
                {{ $t('최근로그인') }}
              </div>
            </button>
            <button class="sns-apple" @click="$loginWithApple">
              <i class="icon-apple" />
              <span>{{ $t('애플로시작하기') }}</span>
              <div v-if="recentlyLoginSns === 'apple'" class="recent">
                {{ $t('최근로그인') }}
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const bodyClass = ref('')
const { $t } = useNuxtApp()
const { isWebview } = useWebviewBridge()

useHead({
  bodyAttrs: {
    class: bodyClass,
  },
})

useEventListener('resize', () => {
  if (window.innerWidth < 768) {
    bodyClass.value = 'lock'
  }
  else {
    bodyClass.value = ''
  }
})

const nuxt = useNuxtApp()

const { hideLoginPopup, jwtCookie, loginWithGoogle, loginWithKakao, loginWithApple, recentlyLoginSns } = useAuth()

// 로그인 후 현재 페이지를 새로고침한다. 최초 가입이면 ?welcome=1 을 붙여
// 랜딩(default.vue)에서 프로필 팝업이 뜨게 한다.
function reloadAfterLogin(isNewUser?: boolean) {
  if (isNewUser) {
    const url = new URL(window.location.href)
    url.searchParams.set('welcome', '1')
    window.location.href = url.toString()
  }
  else {
    location.reload()
  }
}
const runtimeConfig = useRuntimeConfig()

const id = ref('')
const password = ref('')

const invalidMessage = ref('')

const { locale } = useI18n()

async function login() {
  if (id.value === '') {
    invalidMessage.value = $t('아이디를입력해주세요')
    return
  }

  if (password.value === '') {
    invalidMessage.value = $t('비밀번호를입력해주세요')
    return
  }

  const { data } = await useAPI<any>('/hml/v1/auth/watv/login', {
    method: 'post',
    body: {
      id: id.value,
      pwd: password.value,
      languageGbSn: locale.value,
      os: window.navigator.userAgent,
    },
  })

  if (data.value?.errorCode !== '00') {
    if (data.value?.errorCode === '04') {
      invalidMessage.value = $t(
        '비밀번호가일치하지않습니다br비밀번호는대소문자를구분하오니다시한번확인하시고로그인해주세요',
      )
    }
    else if (data.value?.errorCode === '30') {
      invalidMessage.value = $t('가입하지않은아이디입니다br아이디를정확하게입력해주세요')
    }
    else {
      invalidMessage.value = data.value?.outMsgTxt?.replaceAll('\\n\\n', '<br />') ?? '로그인에 실패했습니다.'
    }
    return
  }

  invalidMessage.value = ''
  jwtCookie.value = data.value.token
  recentlyLoginSns.value = 'watv'

  reloadAfterLogin(data.value.isNewUser)
}

async function $loginWithApple() {
  if (isWebview.value) {
    useWebviewBridge().loginWithApple()
    return
  }

  const result = await loginWithApple()

  if (!result?.token) {
    return
  }

  jwtCookie.value = result.token
  recentlyLoginSns.value = 'apple'

  reloadAfterLogin(result.isNewUser)
}
</script>

<style scoped>
@import '~/assets/css/setting.css';
@import '~/assets/css/login.css';
</style>
